"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreathingFilters = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var BreathingFilters = (function (_super) {
    __extends(BreathingFilters, _super);
    function BreathingFilters() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.BREATHING_FILTERS,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 11,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(7); }),
            metadata: {
                description: 'Requires 7% oxygen.',
                cardNumber: '114',
                victoryPoints: 2,
            },
        }) || this;
    }
    BreathingFilters.prototype.play = function () {
        return undefined;
    };
    BreathingFilters.prototype.getVictoryPoints = function () {
        return 2;
    };
    return BreathingFilters;
}(Card_1.Card));
exports.BreathingFilters = BreathingFilters;
